<template>
    <div class="incoming-material">
        <div class="df both-side">
            <a-space>
                <range-time :placeholder="['反馈日期', '反馈日期']" :source="requestPayload"
                    :target="['feedbackStartDate', 'feedbackEndDate']" @onChange="handleSearch" style="width: 180px;" />

                <range-time :placeholder="['来料开始日期', '来料结束日期']" :source="requestPayload"
                    :target="['incomingMaterialStartDate', 'incomingMaterialEndDate']" @onChange="handleSearch"
                    style="width: 220px;" />

                <a-select v-model:value="requestPayload.status" placeholder="状态" @change="handleSearch"
                    :options="statusOptions" allowClear style="width: 100px;">
                </a-select>
                <a-input v-model:value="requestPayload.materialBatch" placeholder="物料批号" @change="handleSearch"
                    style="width: 150px;" allowClear></a-input>
                <a-input v-model:value="requestPayload.materialCode" placeholder="物料编码" @change="handleSearch"
                    style="width: 150px;" allowClear></a-input>
                <a-input v-model:value="requestPayload.materialName" placeholder="物料名称" @change="handleSearch"
                    style="width: 150px;" allowClear></a-input>

                <a-input v-model:value="requestPayload.supplierName" placeholder="供应商名称" @change="handleSearch"
                    style="width: 150px;" allowClear></a-input>
            </a-space>

            <a-space>
                <a-button type="primary" size="small" @click="handleUpdateIncomingMaterial('insert', {
                    title: '新增来料问题', data: null, role: 'qualityInspector'
                })">新增来料问题</a-button>
            </a-space>
        </div>

        <div style="height: calc(100vh - 310px);">
            <a-table :data-source="table.data" :columns="columns" rowKey="id" class="space" bordered :pagination="false"
                :rowClassName="setRecordStatus" :loading="loading"
                :scroll="{ x: 'calc(100vw - 300px)', y: 'calc(100vh - 410px)' }">

                <template #problemPhenomenon="{ record }">
                    <div v-for="(item, index) in record.problemPhenomenon.split('#')" :key="index">
                        {{ index + 1 }}：{{ item }}
                    </div>
                </template>

                <template #picture="{ record }">
                    <cus-image :value="record.picture"></cus-image>
                </template>

                <template #video="{ record }">
                    <preview-video :value="record.video" v-if="record.video && record.video !== '[]'"></preview-video>
                </template>

                <template #status="{ record }">
                    <a-tag :color="setRecordStatus(record)" v-if="record.status">
                        {{ record.status }}
                    </a-tag>
                </template>

                <template #recipient="{ record }">
                    <div v-if="record.recipient">
                        {{ record.recipient.split(',')[0] }}
                    </div>
                </template>

                <template #analysisDept="{ record }">
                    {{ record.analysisDept?.split(',')[2] }}{{ record.analysisDept?.split(',')[0] }}
                </template>

                <template #executionDept="{ record }">
                    {{ record.executionDept?.split(',')[2] }}{{ record.executionDept?.split(',')[0] }}
                </template>

                <template #action="{ record }">
                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="handleAction($event, record)">
                                <a-menu-item key="edit"
                                    :disabled="record.status === '已完成' ? true : !updateAuthority(record)">编辑</a-menu-item>
                                <a-menu-item key="analysis"
                                    :disabled="record.status === '已完成' ? true : !analysisAuthority">问题分析</a-menu-item>
                                <a-menu-item key="confirm"
                                    :disabled="record.status === '已完成' ? true : !qualityAuthority">质量确认</a-menu-item>
                                <a-menu-item key="delete"
                                    :disabled="record.status === '已完成' ? true : !qualityAuthority">删除</a-menu-item>
                            </a-menu>
                        </template>
                        <a-button type="primary" size="small">
                            操作
                            <DownOutlined />
                        </a-button>
                    </a-dropdown>
                </template>
            </a-table>
        </div>

        <div class="df both-side" style="margin-top: 5px;">
            <div></div>
            <a-pagination size="small" :total="table.total" :show-total="total => `共 ${total} 条`" class="space"
                show-size-changer @showSizeChange="hanldeUpdatePageNum" v-model:pageSize="table.lineNum"
                :page-size-options="['10', '20', '30', '40', '50']" v-model:current="table.pageNum"
                @change="hanldeUpdatePageNum" />
        </div>

        <incoming-material-form ref="incomingMaterialFormRef" @handleUpdateTable="getData"></incoming-material-form>
    </div>

</template>

<script>
import { defineComponent, ref } from "vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { Modal } from 'ant-design-vue';
import { Toast } from "@/utils";
import { useTable } from "@/views/notice/serve/table";
import { getIncomingMaterialProblemList, deleteIncomingMaterialProblem, saveIncomingMaterialProblem } from '@/request/view/dailyQualityInspection.js';
import { DownOutlined } from '@ant-design/icons-vue';
import { statusOptions } from './data';
import { serialModelOptions } from '@/components/cascader/option';
import rangeTime from '@/components/daypicker/index.vue';
import seriesTypeCascader from '@/components/cascader/index.vue';
import incomingMaterialForm from '@/views/productDaily/problem/incomingMaterialForm.vue';
import cusImage from '@/components/img/index.vue';
import cusVideo from '@/components/video/index.vue';
import previewVideo from '@/components/video/preview.vue';

export default defineComponent({
    components: {
        rangeTime,
        seriesTypeCascader,
        incomingMaterialForm,
        cusImage,
        cusVideo,
        previewVideo,
        DownOutlined,
    },
    setup(props, context) {
        const {
            requestConfig,
            table,
            requestPayload,
            initPayload,
            getListData,
            searchData,
            deleteRecords,
        } = useTable();

        const loading = ref(false);

        const route = useRoute();

        const user = useStore().state.user.user;

        const updateAuthority = (record) => user.id === record.createUserId;

        const developanAlysisAuthority = user.firstLevelDepartment === '采购部' || user.firstLevelDepartment === '研发中心';

        const productAlysisAuthority = user.firstLevelDepartment === '供应链部';

        const analysisAuthority = process.env.NODE_ENV === 'production' ? productAlysisAuthority : developanAlysisAuthority;

        const qualityAuthority = user.firstLevelDepartment === '质量部';

        const incomingMaterialFormRef = ref();

        requestConfig.pull_fn = getIncomingMaterialProblemList;

        requestConfig.delete_fn = deleteIncomingMaterialProblem;

        initPayload({
            feedbackEndDate: null,
            feedbackStartDate: null,
            incomingMaterialEndDate: null,
            incomingMaterialStartDate: null,
            lineNum: null,
            materialBatch: route.query.materialBatch,
            materialCode: null,
            materialName: route.query.materialName,
            produceOrTpc: route.meta.produceOrTpc,
            pageNum: null,
            status: null,
            supplierName: null
        });

        const columns = [
            { title: "序号", dataIndex: "serialNumber", align: "center", width: "60px", fixed: "left" },
            { title: "反馈日期", dataIndex: "feedbackDate", align: "center", width: "170px", fixed: "left" },
            { title: "来料日期", dataIndex: "incomingMaterialDate", align: "center", width: "100px" },
            { title: "物料名称", dataIndex: "materialName", align: "center", width: "160px" },
            { title: "物料批号", dataIndex: "materialBatch", align: "center", width: "160px" },
            { title: "物料编码", dataIndex: "materialCode", align: "center", width: "160px" },
            { title: "规格型号", dataIndex: "specificationAndModel", align: "center", width: "160px" },
            { title: "供应商名称", dataIndex: "supplierName", align: "center", width: "260px" },
            { title: "问题现象", dataIndex: "problemPhenomenon", align: "center", width: "300px", slots: { customRender: "problemPhenomenon" } },
            { title: "图片", dataIndex: "picture", align: "center", width: "150px", slots: { customRender: 'picture' } },
            { title: "视频", dataIndex: "video", align: "center", width: "150px", slots: { customRender: 'video' } },
            { title: "情况确认和分析", dataIndex: "confirmationAndAnalysis", align: "center", width: "175px" },
            { title: "根本原因", dataIndex: "rootCauseAnalysis", align: "center", width: "150px" },
            { title: "临时措施", dataIndex: "temporaryMeasures", align: "center", width: "180px" },
            { title: "闭环措施", dataIndex: "closedLoopMeasures", align: "center", width: "180px" },
            { title: "通知人", dataIndex: "recipient", align: "center", width: "160px", slots: { customRender: "recipient" } },
            { title: "执行确认", dataIndex: "implementationMeasures", align: "center", width: "180px" },
            {
                title: '执行部门',
                children: [
                    { title: "反馈部门", dataIndex: "feedbackDept", align: "center", width: "160px" },
                    { title: "分析部门", dataIndex: "analysisDept", align: "center", width: "160px", slots: { customRender: 'analysisDept' } },
                    { title: "执行部门", dataIndex: "executionDept", align: "center", width: "160px", slots: { customRender: 'executionDept' } },
                    { title: "监督部门", dataIndex: "supervisionDept", align: "center", width: "160px" },
                ]
            },
            { title: "状态", dataIndex: "status", align: "center", width: "100px", slots: { customRender: 'status' } },
            { title: "备注", dataIndex: "notes", align: "center", width: "160px" },
            { title: "操作", slots: { customRender: 'action' }, align: "center", width: "120px", fixed: "right" }
        ];

        const getData = () => {
            loading.value = true;
            getListData().then(() => {
                table.data.forEach((item, index) => {
                    item.serialNumber = index + 1 + ((table.pageNum - 1) * 10);
                });
                loading.value = false;
            });
        }

        const hanldeUpdatePageNum = (page, size) => {
            table.pageNum = page;
            table.lineNum = size;
            getData()
        };

        const handleDelete = (record) => {
            deleteRecords([record.id], { title: "确认删除？" }).then(() => {
                getData();
            });
        }

        const handleSearch = () => {
            table.pageNum = 1;
            getData();
        };

        const handleUpdateIncomingMaterial = (type, option) => {
            incomingMaterialFormRef.value.showModal(type, option);
        };

        const handleAction = (e, record) => {
            const { key } = e;
            switch (key) {
                case 'edit':
                    handleUpdateIncomingMaterial('edit', {
                        title: '修改信息', data: record, role: 'qualityInspector'
                    });
                    break;
                case 'delete':
                    handleDelete(record);
                    break;
                case 'analysis':
                    handleUpdateIncomingMaterial('analysis', {
                        title: '分析原因', data: record, role: 'supplyChain'
                    })
                    break;
                case 'confirm':
                    checkConfirm(record);
                    break;
                default:
                    break;
            }
        };

        const setRecordStatus = (record, index) => {
            let rowClassName = '';
            const { status } = record;
            switch (status) {
                case '分析中':
                    rowClassName = 'warning';
                    break;
                case '进行中':
                    rowClassName = 'warning';
                    break;
                case '无法处理':
                    rowClassName = 'fail';
                    break;
                case '已完成':
                    rowClassName = 'success';
                    break;
                default:
                    break;
            }
            return rowClassName;
        };

        const checkConfirm = (record) => {
            Modal.warning({
                title: () => '确认该条来料问题处理完成？',
                okText: "确认",
                closable: true,
                maskClosable: true,
                onOk: () => {
                    saveIncomingMaterialProblem({
                        id: record.id,
                        status: '已完成',
                        supervisionDept: `${user.firstLevelDepartment}${user.nickName}`
                    }).then((res) => {
                        const type = res.code === 200 ? 'success' : 'warning';
                        Toast(type, res.message, 3);
                        getData()
                    });
                }
            });
        };

        const init = () => {
            getData();
            route.query.materialName = null;
            route.query.materialBatch = null;
        };

        init();

        return {
            loading,
            serialModelOptions,
            table,
            columns,
            getData,
            statusOptions,
            handleAction,
            setRecordStatus,
            incomingMaterialFormRef,
            requestPayload,
            handleDelete,
            handleSearch,
            hanldeUpdatePageNum,
            handleUpdateIncomingMaterial,
            qualityAuthority,
            analysisAuthority,
            updateAuthority,
        };
    },
});
</script>

<style lang="less" scoped>
.incoming-material {
    :deep(.warning) td {
        background-color: #ffff9b !important;
    }

    :deep(.fail) td {
        background-color: #fff1f0 !important;
    }

    :deep(.success) td {
        background-color: #c7ffdb !important;
    }

    .space {
        margin-top: 20px;
    }

    :deep(.ant-table-thead > tr > th) {
        padding: 6px 8px;
    }

    :deep(.ant-table-tbody > tr > td) {
        padding: 8px;
    }
}
</style>
